import { Injectable } from '@angular/core';

export type UserAgentType = 'Windows' | 'macOS' | 'Android' | 'iOS' | 'Linux' | 'Unknown';

@Injectable({
  providedIn: 'root',
})
export class UserAgentService {
  getUserAgent() {
    const ua = navigator.userAgent;

    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    else if (/Android/i.test(ua)) return 'Android';
    else if (/Windows/i.test(ua)) return 'Windows';
    else if (/Mac OS/i.test(ua)) return 'macOS';
    else if (/Linux/i.test(ua)) return 'Linux';
    else return 'Unknown';
  }
}
